<template>
  <div id="about" class="teal white-text">
    <PageHeader fixed />
    <main class="pb-0">
      <div class="container pt-9 mt-9">
        <div class="flex mb-6 justify-center lg:justify-start">
          <h4 class="green white-text txt--bold pv-2 ph-3">About Us</h4>
        </div>
        <div class="relative flex flex-col lg:flex-row items-center gap-4 lg:gap-12">
          <PictureImg
            src="/images/about/rasylva-logo-circle"
            alt="Rasylva.id"
            :extensions="['svg']"
            img-class="block w-4/5 mx-auto lg:w-auto lg:h-[30vh]"
          />
          <p class="text-lg lg:text-2xl text-center lg:text-left">
            <b>Rasylva.id (PT Rasylva Digital Lestari</b>) adalah perusahaan pengembangan software yang berfokus
            mengintegrasikan teknologi dengan bidang <i>natural science</i> untuk menghadirkan solusi digital yang
            inovatif.
          </p>
        </div>
      </div>
      <div class="container mt-9">
        <div class="relative flex flex-col lg:flex-row-reverse items-center gap-4 lg:gap-8">
          <PictureImg
            src="/images/about/vision"
            alt=""
            :extensions="['png']"
            img-class="w-full lg:w-auto lg:h-[40vh]"
          />
          <div>
            <div class="flex justify-center lg:justify-start">
              <h4 class="green white-text txt--bold pv-2 ph-3">Our Vision</h4>
            </div>
            <p class="text-lg lg:text-2xl mt-2 text-center lg:text-left">
              <b>Mengintegrasikan teknologi dengan bidang <i>natural science</i></b
              >, sehingga tercipta solusi inovatif yang mendukung pembangunan keberlanjutan.
            </p>
          </div>
        </div>
      </div>
      <div class="flex flex-col bg-teal-to-white black-text pt-9 pb-9 mt-4 mb-9 gap-6 lg:gap-2">
        <div class="container">
          <div class="flex justify-center lg:justify-start lg:mb-2">
            <h4 class="green white-text txt--bold pv-2 ph-3">Our Mission</h4>
          </div>
        </div>
        <div class="relative container flex flex-col lg:flex-row items-center gap-4 lg:gap-12">
          <PictureImg
            src="/images/about/mission1"
            alt=""
            :extensions="['webp', 'png']"
            img-class="block w-3/5 mx-auto lg:w-auto lg:h-[50vh]"
          />
          <p class="text-lg lg:text-2xl text-center lg:text-left">
            <b>Mengembangkan website dan aplikasi</b> sebagai solusi digital di bidang natural science.
          </p>
        </div>
        <div class="relative container flex flex-col lg:flex-row-reverse items-center gap-4 lg:gap-12 mt-0 lg:-mt-16">
          <PictureImg
            src="/images/about/mission2"
            alt=""
            :extensions="['png']"
            img-class="block w-3/5 mx-auto lg:w-auto lg:h-[50vh]"
          />
          <p class="text-lg lg:text-2xl text-center lg:text-right">
            <b>Mengadakan pelatihan dan publikasi</b> tentang penerapan teknologi di bidang <i>natural science</i>.
          </p>
        </div>
        <div class="relative container flex flex-col lg:flex-row items-center gap-4 lg:gap-12 mt-0 lg:-mt-16">
          <PictureImg
            src="/images/about/mission3"
            alt=""
            :extensions="['png']"
            img-class="block w-3/5 mx-auto lg:w-auto lg:h-[50vh]"
          />
          <p class="text-lg lg:text-2xl text-center lg:text-left">
            <b>Berkontribusi terhadap ilmu pengetahuan</b> di bidang <i>natural science</i>.
          </p>
        </div>
      </div>
      <div class="container mv-9">
        <div class="flex mb-6 justify-center lg:justify-start">
          <h4 class="green white-text txt--bold pv-2 ph-3">Our Journey</h4>
        </div>
        <div>
          <div>
            <div class="flex relative border-b-2 border-b-green pb-2 pl-1">
              <div
                class="absolute translate-y-1/2 flex justify-center items-center bottom-0 left-0 green rounded-full w-32 h-32 drop-shadow-xl"
              >
                <div
                  class="flex flex-col gap-1 justify-center items-center green rounded-full w-28 h-28 border-2 border-teal text-xl lg:text-3xl font-bold"
                >
                  2019
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M1 3v2h22V3a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2m3 1a1 1 0 1 1 1-1a1 1 0 0 1-1 1m3 0a1 1 0 1 1 1-1a1.003 1.003 0 0 1-1 1M1 6v14a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V6Zm8.1 9.3l1.3 1.3l-.7.7l-.7.7l-2-2l-2-2l2-2l2-2l.7.7l.7.7l-1.3 1.3L7.8 14Zm7.9.7l-2 2l-.7-.7l-.7-.7l1.3-1.3l1.3-1.3l-1.3-1.3l-1.3-1.3l.7-.7l.7-.7l2 2l2 2Z"
                    />
                  </svg>
                </div>
              </div>
              <h5 class="green ml-36 pv-2 ph-3 text-lg lg:text-3xl font-bold">Pengembangan Aplikasi Inventum</h5>
            </div>
            <div class="border-l-4 border-teal-dark pt-2 pb-36 ml-16">
              <p class="ml-20 text-base lg:text-2xl">
                Rasylva.id memulai langkahnya dengan mengembangkan aplikasi pertama, yaitu Inventum. Aplikasi ini diuji
                coba oleh sejumlah praktisi yang terlibat dalam proyek di bidang ekologi dan kehutanan. Feedback yang
                diterima selama uji coba menjadi dasar pengembangan fitur-fitur tambahan, memastikan aplikasi tersebut
                dapat memenuhi kebutuhan pengguna di bidang ekologi dan kehutanan.
              </p>
            </div>
          </div>
          <div class="-mt-28 lg:-mt-16">
            <div class="flex relative border-b-2 border-b-green pb-2 pl-1">
              <div
                class="absolute translate-y-1/2 flex justify-center items-center bottom-0 left-0 green rounded-full w-32 h-32 drop-shadow-xl"
              >
                <div
                  class="flex flex-col gap-1 justify-center items-center green rounded-full w-28 h-28 border-2 border-teal text-xl lg:text-3xl font-bold"
                >
                  2021
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 512 512">
                    <path
                      fill="currentColor"
                      d="M477.64 38.26a4.75 4.75 0 0 0-3.55-3.66c-58.57-14.32-193.9 36.71-267.22 110a317 317 0 0 0-35.63 42.1c-22.61-2-45.22-.33-64.49 8.07C52.38 218.7 36.55 281.14 32.14 308a9.64 9.64 0 0 0 10.55 11.2l87.31-9.63a194 194 0 0 0 1.19 19.7a19.53 19.53 0 0 0 5.7 12L170.7 375a19.6 19.6 0 0 0 12 5.7a194 194 0 0 0 19.59 1.19l-9.58 87.2a9.65 9.65 0 0 0 11.2 10.55c26.81-4.3 89.36-20.13 113.15-74.5c8.4-19.27 10.12-41.77 8.18-64.27a317.7 317.7 0 0 0 42.21-35.64C441 232.05 491.74 99.74 477.64 38.26M294.07 217.93a48 48 0 1 1 67.86 0a47.95 47.95 0 0 1-67.86 0"
                    />
                    <path
                      fill="currentColor"
                      d="M168.4 399.43c-5.48 5.49-14.27 7.63-24.85 9.46c-23.77 4.05-44.76-16.49-40.49-40.52c1.63-9.11 6.45-21.88 9.45-24.88a4.37 4.37 0 0 0-3.65-7.45a60 60 0 0 0-35.13 17.12C50.22 376.69 48 464 48 464s87.36-2.22 110.87-25.75A59.7 59.7 0 0 0 176 403.09c.37-4.18-4.72-6.67-7.6-3.66"
                    />
                  </svg>
                </div>
              </div>
              <h5 class="green ml-36 pv-2 ph-3 text-lg lg:text-3xl font-bold">Rilis Aplikasi Inventum!</h5>
            </div>
            <div class="border-l-4 border-teal-dark pt-2 pb-36 ml-16">
              <p class="ml-20 text-base lg:text-2xl">
                Setelah dua tahun melalui proses uji coba dan penyempurnaan, akhirnya Rasylva.id dengan bangga merilis
                aplikasi pertamanya, yaitu Inventum: Alat Inventarisasi Tumbuhan!
              </p>
            </div>
          </div>
          <div class="-mt-28 lg:-mt-16">
            <div class="flex relative border-b-2 border-b-green pb-2 pl-1">
              <div
                class="absolute translate-y-1/2 flex justify-center items-center bottom-0 left-0 green rounded-full w-32 h-32 drop-shadow-xl"
              >
                <div
                  class="flex flex-col gap-1 justify-center items-center green rounded-full w-28 h-28 border-2 border-teal text-xl lg:text-3xl font-bold"
                >
                  2025
                  <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                    <path
                      fill="currentColor"
                      d="M2 5v14c0 .86 1.012 1.318 1.659.753l8-7a1 1 0 0 0 0-1.506l-8-7C3.012 3.682 2 4.141 2 5m11 0v14c0 .86 1.012 1.318 1.659.753l8-7a1 1 0 0 0 0-1.506l-8-7C14.012 3.682 13 4.141 13 5"
                    />
                  </svg>
                </div>
              </div>
              <h5 class="green ml-36 pv-2 ph-3 text-lg lg:text-3xl font-bold">Legalitas Badan Usaha</h5>
            </div>
            <div class="border-l-4 border-teal-dark pt-2 pb-9 ml-16">
              <p class="ml-20 text-base lg:text-2xl">
                Tahun ini menjadi tonggak penting bagi Rasylva.id karena telah resmi mengukuhkan status hukumnya sebagai
                <b>PT Rasylva Digital Lestari</b>, berdasarkan Surat Keputusan Menteri Hukum Republik Indonesia Nomor
                AHU-046866.AH.01.30.Tahun 2025. Ke depannya, legalitas ini dapat membuka jalan bagi kolaborasi strategis
                dan ekspansi layanan digital yang berdampak.
              </p>
            </div>
          </div>
          <div class="-mt-16 lg:-mt-16">
            <div class="flex relative border-b-2 border-b-green pb-2 pl-1">
              <h5 class="green ml-36 pv-2 ph-3 text-lg lg:text-3xl font-bold">Membuka Jasa Web/App Development</h5>
            </div>
            <div class="border-l-4 border-teal-dark pt-2 pb-9 ml-16">
              <p class="ml-20 text-base lg:text-2xl">
                Memperluas cakupan layanannya, Rasylva.id mulai menghadirkan jasa pengembangan software berbasis sains
                dan teknologi. Dengan pendekatan yang terintegrasi dan berorientasi pada kebutuhan bidang natural
                science, Rasylva.id berkomitmen untuk menghadirkan software yang berkualitas, customizable, dan
                maintainable sebagai solusi digital yang berkelanjutan.
              </p>
            </div>
          </div>
          <div class="-mt-16 lg:-mt-16">
            <div class="flex relative border-b-2 border-b-green pb-2 pl-1">
              <h5 class="green ml-36 pv-2 ph-3 text-lg lg:text-3xl font-bold">Pengembangan Aplikasi Berikutnya</h5>
            </div>
            <div class="border-l-4 border-teal-dark pt-2 pb-9 ml-16">
              <p class="ml-20 text-base lg:text-2xl">
                Rasylva.id sedang mengembangkan dua aplikasi baru dan berencana untuk meluncurkannya pada tahun 2026.
                <b>Stay tuned untuk inovasi selanjutnya!</b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col bg-teal-to-white black-text pt-9 pb-9 mt-4 gap-6 lg:gap-2">
        <div class="container-lg mb-8">
          <div class="flex mb-6 justify-center lg:justify-start">
            <h4 class="green white-text txt--bold pv-2 ph-3">Our Founders</h4>
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-2 lg:flex-row gap-12 text-center lg:text-left">
            <div class="flex-item green white-text p-3 outline-4 outline-offset-8 outline-green">
              <div class="flex flex-col gap-4 lg:flex-row">
                <div>
                  <PictureImg
                    src="/images/about/about-photo-rizqi"
                    version="1"
                    alt="About Photo Rizqi"
                    :extensions="['webp', 'png']"
                    :lazy="false"
                    :img-style="{ width: '128px' }"
                  />
                </div>
                <div class="flex-item">
                  <h5 class="m-0 mb-1 text-lg teal pv-1 ph-1 font-bold">Mgs. M. Rizqi Fadhlurrahman, S.Kom.</h5>
                  <p class="m-0 mb-1 font-bold">
                    Co-Founder Rasylva.id
                    <br />
                    Solopreneur & Software Engineer
                    <br />
                    Fakultas Ilmu Komputer UI | 2013
                  </p>
                  <div class="flex justify-center lg:justify-start gap-3">
                    <a
                      href="https://www.linkedin.com/in/mgsrizqi"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <g fill="currentColor">
                          <path
                            fill-rule="evenodd"
                            d="M12.51 8.796v1.697a3.74 3.74 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766c-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483a1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.6 1.6 0 0 1 1.6 1.606"
                            clip-rule="evenodd"
                          />
                          <path d="M7.2 8.809H4V19.5h3.2z" />
                        </g>
                      </svg>
                    </a>
                    <a
                      href="https://github.com/rizqirizqi"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          fill-rule="evenodd"
                          d="M12.006 2a9.85 9.85 0 0 0-6.484 2.44a10.32 10.32 0 0 0-3.393 6.17a10.48 10.48 0 0 0 1.317 6.955a10.05 10.05 0 0 0 5.4 4.418c.504.095.683-.223.683-.494c0-.245-.01-1.052-.014-1.908c-2.78.62-3.366-1.21-3.366-1.21a2.7 2.7 0 0 0-1.11-1.5c-.907-.637.07-.621.07-.621c.317.044.62.163.885.346c.266.183.487.426.647.71c.135.253.318.476.538.655a2.08 2.08 0 0 0 2.37.196c.045-.52.27-1.006.635-1.37c-2.219-.259-4.554-1.138-4.554-5.07a4.02 4.02 0 0 1 1.031-2.75a3.77 3.77 0 0 1 .096-2.713s.839-.275 2.749 1.05a9.26 9.26 0 0 1 5.004 0c1.906-1.325 2.74-1.05 2.74-1.05c.37.858.406 1.828.101 2.713a4.02 4.02 0 0 1 1.029 2.75c0 3.939-2.339 4.805-4.564 5.058a2.47 2.47 0 0 1 .679 1.897c0 1.372-.012 2.477-.012 2.814c0 .272.18.592.687.492a10.05 10.05 0 0 0 5.388-4.421a10.47 10.47 0 0 0 1.313-6.948a10.32 10.32 0 0 0-3.39-6.165A9.85 9.85 0 0 0 12.007 2Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://x.com/rizqirizqi"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="m17.687 3.063l-4.996 5.711l-4.32-5.711H2.112l7.477 9.776l-7.086 8.099h3.034l5.469-6.25l4.78 6.25h6.102l-7.794-10.304l6.625-7.571zm-1.064 16.06L5.654 4.782h1.803l10.846 14.34z"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://mgsrizqi.com"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          d="M16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2m-5.15 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56M14.34 14H9.66c-.1-.66-.16-1.32-.16-2s.06-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2M12 19.96c-.83-1.2-1.5-2.53-1.91-3.96h3.82c-.41 1.43-1.08 2.76-1.91 3.96M8 8H5.08A7.92 7.92 0 0 1 9.4 4.44C8.8 5.55 8.35 6.75 8 8m-2.92 8H8c.35 1.25.8 2.45 1.4 3.56A8 8 0 0 1 5.08 16m-.82-2C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2M12 4.03c.83 1.2 1.5 2.54 1.91 3.97h-3.82c.41-1.43 1.08-2.77 1.91-3.97M18.92 8h-2.95a15.7 15.7 0 0 0-1.38-3.56c1.84.63 3.37 1.9 4.33 3.56M12 2C6.47 2 2 6.5 2 12a10 10 0 0 0 10 10a10 10 0 0 0 10-10A10 10 0 0 0 12 2"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://www.instagram.com/mgsrizqi"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          fill-rule="evenodd"
                          d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M12 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m-5 3a5 5 0 1 1 10 0a5 5 0 0 1-10 0"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <p>
                Rizqi memiliki pengalaman dalam beberapa proyek pengembangan software dan motion graphic design. Ia
                senang memecahkan masalah yang kompleks dan juga sangat antusias dalam membangun software yang
                bermanfaat untuk membuat suatu hal menjadi lebih efektif dan efisien. Karena alasan itulah, Rizqi
                membangun Rasylva.id.
              </p>
            </div>
            <div class="flex-item green white-text p-3 outline-4 outline-offset-8 outline-green">
              <div class="flex flex-col gap-4 lg:flex-row">
                <div>
                  <PictureImg
                    src="/images/about/about-photo-rahmia"
                    alt="About Photo Rahmia"
                    version="1"
                    :extensions="['webp', 'png']"
                    :lazy="false"
                    :img-style="{ width: '128px' }"
                  />
                </div>
                <div class="flex-item">
                  <h5 class="m-0 mb-1 text-lg teal pv-1 ph-1 font-bold">Rahmia Nugraha, S.Hut., M.Sc.</h5>
                  <p class="m-0 mb-1 font-bold">
                    Co-Founder Rasylva.id
                    <br />
                    Magister Biologi UGM | 2019
                    <br />
                    KSHE Fakultas Kehutanan IPB | 2013
                  </p>
                  <div class="flex justify-center lg:justify-start gap-3">
                    <a
                      href="https://www.linkedin.com/in/rahmia-nugraha"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 24 24">
                        <g fill="currentColor">
                          <path
                            fill-rule="evenodd"
                            d="M12.51 8.796v1.697a3.74 3.74 0 0 1 3.288-1.684c3.455 0 4.202 2.16 4.202 4.97V19.5h-3.2v-5.072c0-1.21-.244-2.766-2.128-2.766c-1.827 0-2.139 1.317-2.139 2.676V19.5h-3.19V8.796h3.168ZM7.2 6.106a1.61 1.61 0 0 1-.988 1.483a1.595 1.595 0 0 1-1.743-.348A1.607 1.607 0 0 1 5.6 4.5a1.6 1.6 0 0 1 1.6 1.606"
                            clip-rule="evenodd"
                          />
                          <path d="M7.2 8.809H4V19.5h3.2z" />
                        </g>
                      </svg>
                    </a>
                    <a
                      href="https://www.researchgate.net/profile/Rahmia-Nugraha"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="15px" height="20px" viewBox="0 0 384 512">
                        <path
                          fill="currentColor"
                          d="M228.66 408.101c-20.194-21.973-47.218-57.268-69.698-97.166c37.134-8.685 64.633-43.55 64.633-78.384c0-51.345-39.88-75.176-92.163-75.176c-27.023 0-48.583 1.365-68.716 1.365c-18.369 0-36.722 0-48.154-.445V171.6l17.401 3.192c11.97 2.302 18.783 7.765 18.783 36.214v180.6c0 28.435-6.813 33.928-18.783 36.2l-17.4 3.252v13.259c12.367-.445 33.912-1.351 55.473-1.351c20.624 0 47.217.906 58.68 1.35v-13.258l-23.847-3.253c-12.366-1.796-18.813-7.764-18.813-36.2v-76.542c11.002.921 20.624.921 35.325.921c27.96 49.95 54.551 87.56 69.652 104.962c13.78 16.526 34.85 27.054 61.442 27.054c7.781 0 16.023-1.367 21.054-3.683v-11.894c-16.496 0-32.992-11.477-44.87-24.321zM119.064 295.344c-15.591 0-22.434-.414-33.008-1.41V178.918c10.574-.92 24.752-.92 37.136-.92c38.531 0 61.427 20.195 61.427 56.839c0 36.215-24.736 60.506-65.555 60.506M258.998 179.64c-.46-2.409-.875-5.217-1.243-8.456c-.383-3.268-.63-7.104-.782-11.63c-.154-4.496-.215-9.99-.215-16.282c0-6.323.061-11.74.215-16.25c.152-4.528.399-8.41.782-11.648c.368-3.223.782-6.046 1.243-8.455a51 51 0 0 1 1.78-6.982c3.943-11.923 10.405-20.885 19.443-26.901C289.244 67.02 300.308 64 313.443 64c6.752 0 12.875.782 18.307 2.377c5.371 1.581 10.189 3.76 14.44 6.553c4.189 2.762 7.81 6.015 10.802 9.698a53 53 0 0 1 7.474 11.878c.75 1.35.537 2.425-.66 3.176l-16.68 6.858c-1.413.753-2.41.37-3.193-1.12c-3.743-6.936-6.936-11.493-12.183-14.807c-5.31-3.3-10.22-4.865-18.308-4.865c-8.793 0-12.721 1.749-18.23 5.693c-5.463 3.867-9.468 8.732-11.832 16.143c-.474 1.335-.905 2.993-1.41 4.942c-.415 1.98-.753 4.404-.967 7.242c-.215 2.84-.415 6.353-.598 10.497c-.123 4.144-.184 9.177-.184 15.008c0 5.86.061 10.894.184 15.038c.184 4.128.383 7.641.598 10.48c.214 2.87.552 5.279.966 7.274c.507 1.919.937 3.575 1.411 4.927c2.364 7.38 5.74 11.415 10.712 14.654c4.911 3.284 10.557 5.648 19.35 5.648c7.811 0 14.962-2.225 19.626-5.618c4.62-3.39 8.456-7.87 10.175-13.994c.753-2.579 1.72-5.786 2.38-9.714c.598-3.929.598-8.087.598-13.825c0-.907-.508-1.367-1.352-1.367h-26.716c-1.504 0-2.24-.736-2.24-2.24v-15.314c0-1.52.736-2.257 2.24-2.257h49.028c1.535 0 2.257.737 2.257 2.257v13.09c0 6.935 0 13.365-.722 19.32c-.691 5.953-1.626 11.109-2.808 14.868c-3.744 11.77-9.682 20.15-18.782 26.394c-9.131 6.291-20.9 9.682-33.684 9.682c-13.135 0-24.199-3.022-33.221-9.022c-9.039-6.077-15.5-14.993-19.443-26.916a51 51 0 0 1-1.78-6.997z"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://github.com/rahmianugraha"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          fill-rule="evenodd"
                          d="M12.006 2a9.85 9.85 0 0 0-6.484 2.44a10.32 10.32 0 0 0-3.393 6.17a10.48 10.48 0 0 0 1.317 6.955a10.05 10.05 0 0 0 5.4 4.418c.504.095.683-.223.683-.494c0-.245-.01-1.052-.014-1.908c-2.78.62-3.366-1.21-3.366-1.21a2.7 2.7 0 0 0-1.11-1.5c-.907-.637.07-.621.07-.621c.317.044.62.163.885.346c.266.183.487.426.647.71c.135.253.318.476.538.655a2.08 2.08 0 0 0 2.37.196c.045-.52.27-1.006.635-1.37c-2.219-.259-4.554-1.138-4.554-5.07a4.02 4.02 0 0 1 1.031-2.75a3.77 3.77 0 0 1 .096-2.713s.839-.275 2.749 1.05a9.26 9.26 0 0 1 5.004 0c1.906-1.325 2.74-1.05 2.74-1.05c.37.858.406 1.828.101 2.713a4.02 4.02 0 0 1 1.029 2.75c0 3.939-2.339 4.805-4.564 5.058a2.47 2.47 0 0 1 .679 1.897c0 1.372-.012 2.477-.012 2.814c0 .272.18.592.687.492a10.05 10.05 0 0 0 5.388-4.421a10.47 10.47 0 0 0 1.313-6.948a10.32 10.32 0 0 0-3.39-6.165A9.85 9.85 0 0 0 12.007 2Z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://www.instagram.com/miakibau"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          fill-rule="evenodd"
                          d="M3 8a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5zm5-3a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3zm7.597 2.214a1 1 0 0 1 1-1h.01a1 1 0 1 1 0 2h-.01a1 1 0 0 1-1-1M12 9a3 3 0 1 0 0 6a3 3 0 0 0 0-6m-5 3a5 5 0 1 1 10 0a5 5 0 0 1-10 0"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </a>
                    <a
                      href="https://www.youtube.com/@rahmianugraha"
                      class="flex justify-center items-center teal w-8 h-8 rounded white-text"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 24 24">
                        <path
                          fill="currentColor"
                          fill-rule="evenodd"
                          d="M21.7 8.037a4.26 4.26 0 0 0-.789-1.964a2.84 2.84 0 0 0-1.984-.839c-2.767-.2-6.926-.2-6.926-.2s-4.157 0-6.928.2a2.84 2.84 0 0 0-1.983.839a4.2 4.2 0 0 0-.79 1.965a30 30 0 0 0-.2 3.206v1.5a30 30 0 0 0 .2 3.206c.094.712.364 1.39.784 1.972c.604.536 1.38.837 2.187.848c1.583.151 6.731.2 6.731.2s4.161 0 6.928-.2a2.84 2.84 0 0 0 1.985-.84a4.3 4.3 0 0 0 .787-1.965a30 30 0 0 0 .2-3.206v-1.516a31 31 0 0 0-.202-3.206m-11.692 6.554v-5.62l5.4 2.819z"
                          clip-rule="evenodd"
                        />
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <p>
                Rahmia mempunyai pengalaman dalam pekerjaan lapangan dan juga telah terlibat dalam beberapa proyek
                mengenai biodiversitas. Akan tetapi, hingga saat ini ia merasa bahwa proses pengumpulan dan pengolahan
                data sering kali tidak efisien. Karena alasan itulah, ia bersama dengan Rizqi membangun Rasylva.id.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
    <PageFooter />
  </div>
</template>

<script>
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';
import PictureImg from '~/components/picture-img';

export default {
  components: {
    PageFooter,
    PageHeader,
    PictureImg,
  },
};
</script>

<style lang="scss" scoped>
.bg-teal-to-white {
  background: linear-gradient(to bottom, #389388 0%, #ffffff 20%, #ffffff 100%);
}
</style>
